// src/components/BotaoEnviarEmail.jsx
import React from 'react';
import { useHttpClient } from '../hooks/useHttpClient';
import { usePreventDoubleClick } from '../hooks/usePreventDoubleClick';
import { useNotificacoes } from '../hooks/useNotificacoes';
import './BotaoEmail.module.css';

export default function BotaoEnviarEmail({ idConsumo, className, children }) {
    const { post } = useHttpClient();
    const { exibirErro, exibirSucesso } = useNotificacoes();
    const [safeEnviar, isEnviando] = usePreventDoubleClick(enviarEmail);

    async function enviarEmail() {
        try {
            await post(`/hello-sol/boletos/fatura-email/${idConsumo}`);
        } catch (err) {
            exibirErro(err.message || 'Falha ao enviar fatura por e-mail');
        }
    }

    return (
        <button
            type="button"
            className={className}
            onClick={safeEnviar}
            disabled={isEnviando}
            style={{
                background: 'none',
                color: 'lawngreen',
                border: 'none',
                padding: 0,
                margin: 0,
                cursor: isEnviando ? 'wait' : 'pointer'
            }}
        >
            {isEnviando ? '…' : children}
        </button>
    );
}
